/**
 * Calil の mapping (library_id → 館名) を館名で探せる一覧にする。
 */

export type LibraryEntry = {
  id: number
  name: string
}

export const buildLibraryEntries = (mapping: Record<string, string>): LibraryEntry[] => {
  const entries: LibraryEntry[] = []
  for (const [key, name] of Object.entries(mapping)) {
    const id = Number(key)
    if (!Number.isFinite(id)) continue
    entries.push({ id, name })
  }
  entries.sort((a, b) => a.name.localeCompare(b.name, 'ja'))
  return entries
}

export const filterLibrariesByName = (entries: LibraryEntry[], keyword: string): LibraryEntry[] => {
  const kw = keyword.trim().toLowerCase()
  if (!kw) return entries
  return entries.filter((e) => e.name.toLowerCase().includes(kw))
}
